/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_EmptyInputs */

const cs_clients_tags_empty = /** @type {(inputs: Clients_Tags_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné štítky. Vytvořte jeden nebo přiřaďte nový štítek u klienta.`)
};

const en_clients_tags_empty = /** @type {(inputs: Clients_Tags_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tags yet. Create one or assign a new tag on a client.`)
};

/**
* | output |
* | --- |
* | "No tags yet. Create one or assign a new tag on a client." |
*
* @param {Clients_Tags_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_empty = /** @type {((inputs?: Clients_Tags_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_empty(inputs)
	return cs_clients_tags_empty(inputs)
});